function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { extends as _extends } from "../_virtual/_rollupPluginBabelHelpers.js";
import { createContext, useRef, useState } from 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../hooks/useDocumentsAppConfigs.js";
import useStores from "../hooks/useStores.js";
import DrawableField from "../components/annotation/drawable/DrawableField.js";
import FillableField from "../components/annotation/fillable/FillableField.js";
var AnnotationLayerContext = /*#__PURE__*/createContext(null);

var getRelativeMouseLocation = function getRelativeMouseLocation(_ref, pageAnnotationLayer) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;

  var _pageAnnotationLayer$ = pageAnnotationLayer.getBoundingClientRect(),
      left = _pageAnnotationLayer$.left,
      top = _pageAnnotationLayer$.top;

  return {
    x: clientX - left,
    y: clientY - top
  };
};

function Drawable(_ref2) {
  var children = _ref2.children;
  var currentPageStoreRef = useRef(null);
  var mouseStartRef = useRef(null);
  var pageAnnotationLayerRef = useRef(null);
  var selectedFieldsOriginalLocationsRef = useRef(null);
  var resizingFieldOriginalLocAndDimsRef = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      cursorMode = _useState2[0],
      setCursorMode = _useState2[1];

  var clickTypeRef = useRef(null);

  var _useStores = useStores(),
      assignmentStore = _useStores.assignmentStore;

  var handleMouseDown = function handleMouseDown(_ref3, pageAnnotationLayer, pageStore) {
    var nativeEvent = _ref3.nativeEvent;
    var currentMouse = getRelativeMouseLocation(nativeEvent, pageAnnotationLayer);
    var clickType = nativeEvent.button === 2 ? 'right' : 'left';
    var selectedFields = pageStore.pdfStore.selectedFields;
    var selectedField = selectedFields ? pageStore.pdfStore.lastFieldClicked : undefined;
    var fieldClick = selectedField === null || selectedField === void 0 ? void 0 : selectedField.containsPoint({
      x: pageStore.unScale(currentMouse.x),
      y: pageStore.unScale(currentMouse.y),
      page: pageStore.pageNumber
    });
    var resizeClick = /resize-handle/.test(nativeEvent.target.classList.value);
    if (fieldClick && (selectedField === null || selectedField === void 0 ? void 0 : selectedField.inDefaultValueTypingMode)) return;

    if (clickType === 'right') {
      if (fieldClick) {
        pageStore.pdfStore.setContextMenu({
          position: {
            x: currentMouse.x,
            y: currentMouse.y
          },
          page: pageStore.pageNumber
        });
      }
    } else {
      if (selectedField && fieldClick) {
        pageStore.moveFieldToFront(selectedField);
        selectedFieldsOriginalLocationsRef.current = [];
        selectedFields === null || selectedFields === void 0 ? void 0 : selectedFields.forEach(function (field) {
          selectedFieldsOriginalLocationsRef.current.push({
            x: field.x,
            y: field.y
          });
        });
        resizingFieldOriginalLocAndDimsRef.current = {
          x: selectedField.x,
          y: selectedField.y,
          width: selectedField.width,
          height: selectedField.height
        };

        if (resizeClick) {
          setCursorMode('nwse-resize');
          pageStore.pdfStore.setResizingField(selectedField);
        } else {
          setCursorMode('grabbing');
          pageStore.pdfStore.setIsDraggingField(true);
        }
      } else if (!pageStore.pdfStore.contextMenu) {
        if (pageStore.pdfStore.drawMode || pageStore.pdfStore.copiedFields) {
          pageStore.drawField(currentMouse);
        } else {
          selectedField === null || selectedField === void 0 ? void 0 : selectedField.setInDefaultValueTypingMode(false);
          pageStore.pdfStore.setSelectedFields();
          var newMultiSelectBox = {
            x: pageStore.unScale(currentMouse.x),
            y: pageStore.unScale(currentMouse.y),
            width: 0,
            height: 0
          };
          pageStore.setMultiSelectBox(newMultiSelectBox);
        }
      }

      pageStore.pdfStore.setContextMenu();
    }

    currentPageStoreRef.current = pageStore;
    mouseStartRef.current = currentMouse;
    pageAnnotationLayerRef.current = pageAnnotationLayer;
    clickTypeRef.current = clickType;
    nativeEvent.preventDefault();
    nativeEvent.stopPropagation();
  };

  var handleMouseMove = function handleMouseMove(_ref4, pageAnnotationLayer, pageStore) {
    var nativeEvent = _ref4.nativeEvent;
    var selectedField = pageStore.pdfStore.lastFieldClicked;
    if (selectedField === null || selectedField === void 0 ? void 0 : selectedField.inDefaultValueTypingMode) return;
    pageAnnotationLayer.focus({
      preventScroll: true
    });

    if (mouseStartRef.current && currentPageStoreRef.current && pageAnnotationLayerRef.current && clickTypeRef.current === 'left') {
      var currentMouse = getRelativeMouseLocation(nativeEvent, pageAnnotationLayerRef.current);
      var currentPageStore = currentPageStoreRef.current;
      var mouseStart = mouseStartRef.current;

      if (currentPageStore.multiSelectBox) {
        setCursorMode('crosshair');
        currentPageStore.updateMultiSelectBoxDimensions(mouseStart, currentMouse);
        currentPageStore.selectFieldsInMultiSelectBox();
      }

      if (selectedFieldsOriginalLocationsRef.current && resizingFieldOriginalLocAndDimsRef.current) {
        if (currentPageStore.pdfStore.isDraggingField) {
          currentPageStore.updateDraggingFieldLocations(selectedFieldsOriginalLocationsRef.current, mouseStart, currentMouse);
        } else {
          currentPageStore.updateResizingFieldDimensions(resizingFieldOriginalLocAndDimsRef.current, mouseStart, currentMouse);
        }
      }
    } else if (clickTypeRef.current === null) {
      var _currentMouse = getRelativeMouseLocation(nativeEvent, pageAnnotationLayer);

      pageStore.updateGhostFieldLocations(_currentMouse);
      pageStore.pdfStore.setLastKnownMouseLocation(_currentMouse);
      currentPageStoreRef.current = pageStore;
    }

    nativeEvent.preventDefault();
    nativeEvent.stopPropagation();
  };

  var cleanUp = function cleanUp() {
    var _currentPageStoreRef$, _currentPageStoreRef$2, _currentPageStoreRef$3, _currentPageStoreRef$5;

    (_currentPageStoreRef$ = currentPageStoreRef.current) === null || _currentPageStoreRef$ === void 0 ? void 0 : _currentPageStoreRef$.setMultiSelectBox();
    (_currentPageStoreRef$2 = currentPageStoreRef.current) === null || _currentPageStoreRef$2 === void 0 ? void 0 : _currentPageStoreRef$2.pdfStore.setIsDraggingField(false);
    (_currentPageStoreRef$3 = currentPageStoreRef.current) === null || _currentPageStoreRef$3 === void 0 ? void 0 : _currentPageStoreRef$3.pdfStore.setResizingField();

    if (clickTypeRef.current !== 'right') {
      var _currentPageStoreRef$4;

      (_currentPageStoreRef$4 = currentPageStoreRef.current) === null || _currentPageStoreRef$4 === void 0 ? void 0 : _currentPageStoreRef$4.setGhostFields();
    }

    (_currentPageStoreRef$5 = currentPageStoreRef.current) === null || _currentPageStoreRef$5 === void 0 ? void 0 : _currentPageStoreRef$5.pdfStore.setLastKnownMouseLocation();
    currentPageStoreRef.current = null;
    mouseStartRef.current = null;
    pageAnnotationLayerRef.current = null;
    selectedFieldsOriginalLocationsRef.current = null;
    resizingFieldOriginalLocAndDimsRef.current = null;
    clickTypeRef.current = null;
    setCursorMode(undefined);
  };

  var cleanUpOnMouseEvent = function cleanUpOnMouseEvent(_ref5) {
    var nativeEvent = _ref5.nativeEvent;
    cleanUp();
    nativeEvent.preventDefault();
    nativeEvent.stopPropagation();
  };

  var handleKeyDown = function handleKeyDown(event, pageStore) {
    var selectedField = pageStore.pdfStore.lastFieldClicked;
    if (selectedField === null || selectedField === void 0 ? void 0 : selectedField.inDefaultValueTypingMode) return;

    if (event.key === 'Escape') {
      pageStore.pdfStore.setDrawMode();
      pageStore.setGhostFields();
    } else if (event.key === 'Shift') {
      pageStore.pdfStore.setShiftKeyHeldDown(true);
    }

    if (pageStore.pdfStore.selectedFields) {
      if ((event.metaKey || event.ctrlKey) && event.key === 'c') {
        pageStore.pdfStore.setCopiedFields(_toConsumableArray(pageStore.pdfStore.selectedFields));
        var currentMouse = pageStore.pdfStore.lastKnownMouseLocation;

        if (currentMouse) {
          pageStore.updateGhostFieldLocations(currentMouse);
        }
      } else if (event.key === 'Backspace' || event.key === 'Delete') {
        pageStore.pdfStore.selectedFields.forEach(function (field) {
          pageStore.deleteField(field);
        });
        pageStore.pdfStore.setContextMenu();
        pageStore.pdfStore.setSelectedFields();
        pageStore.pdfStore.setLastFieldClicked();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        pageStore.moveSelectedFields({
          x: 0,
          y: -1
        });
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        pageStore.moveSelectedFields({
          x: 0,
          y: 1
        });
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        pageStore.moveSelectedFields({
          x: 1,
          y: 0
        });
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        pageStore.moveSelectedFields({
          x: -1,
          y: 0
        });
      } else if (event.key === ' ') {
        event.preventDefault();
        pageStore.pdfStore.selectedFields.forEach(function (field) {
          var _assignmentStore$defa;

          if (field.checkboxField && field.data.assignedTo === ((_assignmentStore$defa = assignmentStore.defaultOption) === null || _assignmentStore$defa === void 0 ? void 0 : _assignmentStore$defa.assignmentKey)) {
            field.updateData({
              value: !field.data.value
            });
          }
        });
      }
    }
  };

  var handleKeyUp = function handleKeyUp(event, pageStore) {
    pageStore.pdfStore.setShiftKeyHeldDown(false);
  };

  return jsx(AnnotationLayerContext.Provider, {
    value: {
      Field: DrawableField,
      cursorMode: cursorMode,
      handleMouseDown: handleMouseDown,
      handleMouseMove: handleMouseMove,
      handleMouseUp: cleanUpOnMouseEvent,
      handleMouseLeave: cleanUpOnMouseEvent,
      handleKeyDown: handleKeyDown,
      handleKeyUp: handleKeyUp
    }
  }, children);
}

Drawable.displayName = "Drawable";

function Fillable(_ref6) {
  var children = _ref6.children,
      viewOnly = _ref6.viewOnly,
      signingDisabled = _ref6.signingDisabled,
      modifyingFieldPropertiesEnabled = _ref6.modifyingFieldPropertiesEnabled;

  var _useStores2 = useStores(),
      pdfStore = _useStores2.pdfStore,
      signatureStore = _useStores2.signatureStore;

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Tab') {
      var field = event.shiftKey ? pdfStore.previousField(currentUserId, currentUserPermissions) : pdfStore.nextField(currentUserId, currentUserPermissions);

      if (field) {
        event.preventDefault();
        pdfStore.focusField(field);
      } else if (!event.shiftKey) {
        event.preventDefault();
        var submitButton = document.getElementsByClassName('submit-document-button')[0] || document.getElementsByClassName('create-document-button')[0];

        if (submitButton && !submitButton.disabled) {
          pdfStore.setSelectedFields([]);
          submitButton.focus();
        }
      }
    } else if (event.key === ' ' || event.key === 'Enter') {
      if (pdfStore.isFieldSignable(pdfStore.selectedField, currentUserId, currentUserPermissions)) {
        event.preventDefault();
        signatureStore.signField(pdfStore.selectedField);
      }
    }
  };

  return jsx(AnnotationLayerContext.Provider, {
    value: {
      Field: function Field(props) {
        return jsx(FillableField, _extends({}, props, {
          disabled: viewOnly,
          signingDisabled: signingDisabled,
          modifyingFieldPropertiesEnabled: modifyingFieldPropertiesEnabled
        }));
      },
      handleClick: function handleClick() {
        return pdfStore.setSelectedFields();
      },
      handleKeyDown: handleKeyDown
    }
  }, children);
}

Fillable.displayName = "Fillable";
export default AnnotationLayerContext;
export { Drawable, Fillable };